<template>
  <div class="offer-or-plan-item">
    <div v-if="isSignature" class="d-flex justify-content-between w-100">
      <div
        class="d-flex flex-column flex-md-row align-items-md-center gap-2 w-100"
      >
        <h6 class="text-semibold">{{ item.name }}</h6>
        <span class="text-dark-40 d-none d-md-block">|</span>
        <span class="text-green"> R$ {{ formatPrice(item.price) }} </span>
        <span class="text-dark-40 d-none d-md-block">|</span>
        <span class="fs-14 text-dark-40">
          {{
            !item.num_max_payments
              ? "Recorre até o cliente cancelar"
              : `${item.num_max_payments} recorrências`
          }}
        </span>
        <span class="text-dark-40 d-none d-md-block">|</span>
        <span class="fs-14 text-dark-40">
          {{
            item.test_days
              ? `${item.test_days} dias de teste`
              : "Sem período de teste"
          }}
        </span>
      </div>
      <div class="d-flex gap-3">
        <snow-button
          text="Editar"
          variant="gray"
          @click="$emit('edit', index)"
        />
        <snow-button
          text="Excluir"
          variant="danger"
          @click="$emit('delete', index)"
        />
      </div>
    </div>

    <div v-else>
      <div class="d-flex justify-content-between w-100">
        <div
          class="d-flex flex-column flex-md-row align-items-md-center gap-2 w-100"
        >
          <h6 class="text-semibold">{{ item.name }}</h6>
          <span class="text-dark-40 d-none d-md-block">|</span>
          <span class="text-green ">R$ {{ formatPrice(item.price) }}</span>
          <i
            v-if="item.order_bumps.length"
            class="ph ph-shopping-cart fs-18 mb-md-1"
          />
          <span class="text-dark-40 fs-14">
            {{ formatDate(item) }}
          </span>
        </div>
        <div class="d-flex gap-3">
          <snow-button
            text="Editar"
            variant="gray"
            @click="$emit('edit', index)"
          />
          <snow-button
            text="Excluir"
            variant="danger"
            @click="$emit('delete', index)"
          />
        </div>
      </div>
      <div v-if="item.order_bumps.length">
        <div class="fs-14 text-dark-80 mt-1 mt-md-0 mb-2">
          Order Bump cadastrados:
        </div>
        <div class="d-flex flex-column">
          <div class="d-flex flex-wrap gap-5">
            <div
              v-for="(orderBump, index) in item.order_bumps"
              class="dashed-order-bump"
              :key="index"
            >
              <div
                v-if="orderBump.product_name && orderBump.offer_name"
                class="d-flex align-items-center gap-1 bg-3 rounded-8 px-2 fs-12"
              >
                <span>
                  {{ orderBump.product_name }}
                  /
                  {{ orderBump.offer_name }}
                </span>
                <i
                  class="ph ph-x my-1"
                  @click="$emit('removeOrderBump', index)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { formatMoney } from "@/functions/helpers";
import moment from "moment";
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number
    },
    isSignature: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false
    };
  },
  methods: {
    editItems(index) {
      this.$emit("edit", index);
    },
    formatDate(item) {
      const start = moment(item.start_at).format("DD/MM/YYYY");
      if (item.end_at) {
        const end = moment(item.end_at).format("DD/MM/YYYY");
        return `${start} - ${end}`;
      }
      return `Inicia em ${start}, sem data limite.`;
    },
    formatPrice(val) {
      return formatMoney(val);
    }
  }
};
</script>
<style lang="scss" scoped>
.offer-or-plan-item {
  padding: 16px;
  margin-bottom: 16px;
  border-radius: 16px;
  background-color: #fefefe;
  .ph-x {
    cursor: pointer;
  }
}
</style>
